export const ProtocolResponseValue = {
  TCP: "TCP",
  UDP: "UDP",
  ALL: "ALL",
};
